/**
 * TanStack Query key builders for the `abrechnung` feature (DATEXT billing linkout).
 *
 * Konsument der Preflight-Query ist die Top-Nav (`useDatextNavAction`); die Invalidierung durch
 * Organisations-Mutationen entfällt.
 *
 * The linkout action itself builds a one-time launch URL and is never cached — it is a mutation,
 * not a query, and its result (the launch URL) must never enter the query cache (Security). Only
 * the credential-presence preflight has a cache key.
 */
export const abrechnungKeys = {
  /** Root key for all abrechnung-feature queries — use to invalidate the entire feature cache. */
  all: ['abrechnung'] as const,

  /**
   * DATEXT credential-presence preflight query. Takes no params — the check is scoped to
   * the caller's own organization server-side, never by a client-supplied id — so this is a
   * single, unparameterized cache entry per authenticated principal.
   */
  datextStatus: () => [...abrechnungKeys.all, 'datext-status'] as const,
};
